import { FaqItem } from './faq-item'
import { GuiaSection } from './guide'

export interface Faq {
  q: string
  a: string
}

/**
 * Bloco de FAQ que renderiza o acordeão E emite o schema FAQPage (JSON-LD)
 * a partir do mesmo array — garante rich results sem duplicar o conteúdo.
 */
export function FaqSection({ faqs, title = 'Perguntas frequentes' }: { faqs: Faq[]; title?: string }) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  }

  return (
    <GuiaSection title={title}>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />
      <div className="mt-1">
        {faqs.map((f) => (
          <FaqItem key={f.q} q={f.q} a={f.a} />
        ))}
      </div>
    </GuiaSection>
  )
}
